import React from 'react';

import { Typography } from '@mui/material';

export const FormNotification = ({ notification, variant = 'body1' }) => (
	<Typography variant={variant} color='error'>
		{notification}
	</Typography>
);
